import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"#000000\" id=\"arrow-right\"><g id=\"arrow-right_SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"arrow-right_SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"arrow-right_SVGRepo_iconCarrier\"><path d=\"M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z\" fill=\"#000000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol